// extracted by mini-css-extract-plugin
export default {"item":"AboutCarItem_item__WA06x","title":"AboutCarItem_title__CLTzB"};